/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { memo, useState, useCallback, useEffect } from 'react';
import Styles from '../css/ExpandableRow.module.css';
import { KeyboardArrowDown } from '@mui/icons-material';

const ExpandableRow = ({ labelValues, primaryElement = null, featuredElements = 0, shownElements = 0 }) => {

  const [numFeatured, setNumFeatured] = useState(0);
  const [numShown, setNumShown] = useState(0);

  useEffect(() => {
    setNumFeatured(labelValues.size > featuredElements ? featuredElements : labelValues.size);
  }, [labelValues, featuredElements]);

  useEffect(() => {
    setNumShown((labelValues.size + numFeatured) > shownElements ? shownElements : (labelValues.size + numFeatured));
  }, [labelValues, shownElements, numFeatured])

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleIsExpanded = useCallback(() => setIsExpanded((prev) => !prev), []);

  return (
    <section className={numShown < labelValues.size ? Styles.expandableRow : Styles.row} onClick={() => toggleIsExpanded()}>
      {primaryElement && (
        <div className={Styles.primary}>
          {primaryElement}
        </div>
      )}
      {numShown > 0 && (
        <dl className={Styles.shown}>
          {labelValues !== null && [...labelValues].slice(0, numShown).map(([labelKey, labelValue], index) => (
            <>
              <dt>{labelKey}</dt>
              <dd className={index < featuredElements && Styles.featured}>{labelValue}</dd>
            </>
          ))}
        </dl>
      )}
      {numShown < labelValues.size && (
        <div className={Styles.showMore}>
          {isExpanded ? 'Show Less' : 'Show More'}
          <KeyboardArrowDown
            className={isExpanded && Styles.minimizeIcon}
          />
        </div>
      )}
      {numShown < labelValues.size && isExpanded && (
        <dl className={Styles.shown}>
          {labelValues !== null && numShown < labelValues.size && [...labelValues].slice(numShown).map(([labelKey, labelValue], index) => (
            <>
              <dt>{labelKey}</dt>
              <dd>{labelValue}</dd>
            </>
          ))}
        </dl>
      )}
    </section>
  );
};

export default memo(ExpandableRow);
